
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * Büro seçici.
 *
 * `haric` ile verilen büro(lar) listeden çıkarılır — personeli kendi bürosuna
 * "taşımak" ya da silinen büroyu hedef göstermek anlamsızdır.
 *
 * Tek seçenek kaldığında otomatik seçilir: kullanıcıya tek şıklı bir açılır
 * liste sunmak gereksiz bir tıklamadır.
 */
@Component({})
export default class BuroPicker extends Vue {
  @Prop({}) value!: number | null;
  @Prop({ default: "Büro" }) label!: string;
  @Prop({ default: false }) disabled!: boolean;
  /** Listeden çıkarılacak büro id'leri (tek değer de verilebilir). */
  @Prop({ default: () => [] }) haric!: Array<number> | number | null;
  /** Dışarıdan hazır liste verilirse istek atılmaz (ör. silme önizlemesi). */
  @Prop({ default: null }) items!: Array<any> | null;
  @Prop({ default: () => [] }) errorMessages!: Array<string>;

  secenekler: Array<any> = [];
  yukleniyor: boolean = false;

  get haricListesi(): Array<number> {
    if (this.haric === null || this.haric === undefined) return [];
    return Array.isArray(this.haric) ? this.haric.map(Number) : [Number(this.haric)];
  }

  get ipucu(): string {
    if (!this.yukleniyor && this.secenekler.length === 0) {
      return "Taşınabilecek başka büro bulunmuyor.";
    }
    return "";
  }

  mounted() {
    this.hazirla();
  }

  @Watch("items")
  @Watch("haric")
  hazirla() {
    if (this.items !== null) {
      this.uygula(this.items);
      return;
    }
    this.yukle();
  }

  yukle() {
    this.yukleniyor = true;
    this.$http
      .get("/api/v1/buro-list")
      .then((res: any) => {
        this.uygula(res.data?.data ?? res.data ?? []);
      })
      .finally(() => {
        this.yukleniyor = false;
      });
  }

  uygula(liste: Array<any>) {
    const haric = this.haricListesi;
    this.secenekler = (liste || []).filter((b: any) => !haric.includes(Number(b.id)));

    // Tek seçenek varsa kullanıcıya sormadan seç.
    if (this.secenekler.length === 1 && !this.value) {
      this.secildi(this.secenekler[0].id);
    }
    // Seçili büro listeden çıktıysa (ör. silindi) seçimi temizle.
    if (this.value && !this.secenekler.some((b: any) => Number(b.id) === Number(this.value))) {
      this.secildi(null);
    }
  }

  secildi(id: number | null) {
    this.$emit("input", id);
  }
}
